import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { MessagingConversationApiModel } from '../Models/MessagingConversationApiModel';
import { SpaContext } from '../../../../Classes/spacontext';

interface Conversation {
	reason: string;
	conditionId: number;
	files: Guid[];
	externalData: Guid[];
}
@Injectable()
export class MessagingServiceV2 {
	readonly baseUri = '/api/Client/v2/Units/';

	constructor(private http: VisibaApiHttp, public spaContext: SpaContext) {}

	public startConversation(body: Conversation) {
		return this.http.postTyped<MessagingConversationApiModel>(
			`${this.baseUri}${this.spaContext.unitConfig.Unit.UnitId}/MessagingConversations`,
			body,
		);
	}
}
